import { createAction } from '@reduxjs/toolkit'

export const selectRow = createAction('SELECT_ROW');
export const saveImage = createAction('SAVE_IMAGE');
export const resetEdit = createAction('RESET_EDIT');
export const saveEdit = createAction('SAVE_EDIT');
export const saveText = createAction('SAVE_TEXT');
export const saveIfElse = createAction('SAVE_IFELSE');
export const moveUp = createAction('MOVE_UP');
export const moveDown = createAction('MOVE_DOWN');
export const selectRowUp = createAction('SELECT_ROW_UP');
export const selectRowDown = createAction('SELECT_ROW_DOWN');
export const align = createAction('ALIGN');
export const deleteRow = createAction('DELETE_ROW');
export const clearRowSelection = createAction('CLEAR_ROW_SELECTION');
export const addRow = createAction('ADD_ROW');
export const loadCatalogueDesign = createAction('LOAD_CATALOGUE_DESIGN');
export const loadDesign = createAction('LOAD_DESIGN');
export const newDesign = createAction('NEW_DESIGN');
export const saveDesign = createAction('SAVE_DESIGN');
export const projectFolder = createAction('PROJECT_FOLDER');
export const fetchFailed = createAction('FETCH_FAILED');
export const setDesigns = createAction('SET_DESIGNS');
export const fetchDesigns = createAction('FETCH_DESIGNS');
export const fetchCatalogues = createAction('FETCH_CATALOGUES');
export const setCatalogues = createAction('SET_CATALOGUES');
export const addDesign = createAction('ADD_DESIGN');
export const updateDesign = createAction('UPDATE_DESIGN');
export const showAlert = createAction('SHOW_ALERT');
export const importDesign = createAction('IMPORT_DESIGN');
export const saveMjml = createAction('SAVE_MJML');